import { useState, useEffect } from 'react';
import { getTaches, creerTache, modifierTache, supprimerTache, repartirTaches, reattribuerTache, indisponibleTache } from '../api';

/*
 * Tâches tournantes : table de marque, chrono, goûter, transport…
 * Le coach les définit ; la répartition est automatique et équitable.
 */
const carte = { background: 'var(--card, #161b22)', border: '1px solid var(--border)', borderRadius: 12, padding: '14px 16px', marginBottom: 12 };
const champ = { background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 9, color: 'var(--text)', padding: '8px 10px', fontSize: 14 };
const petit = { fontSize: 12, color: 'var(--muted)' };
const lien = { all: 'unset', cursor: 'pointer', textDecoration: 'underline', fontSize: 12.5 };
const QUAND = { domicile: 'Matchs à domicile', exterieur: 'Matchs à l\'extérieur', tous: 'Chaque rencontre' };
const ICONES = ['🧾', '⏱️', '🍪', '🚗', '🧺', '🏁', '📣', '🧹'];
const SUGGESTIONS = [['Table de marque', '🧾', 'domicile', 1], ['Chronométrage', '⏱️', 'domicile', 1], ['Goûter', '🍪', 'tous', 1], ['Transport', '🚗', 'exterieur', 2]];

function NouvelleTache({ onCree, onAnnule, notifier }) {
  const [f, setF] = useState({ nom: '', icone: '🧾', quand: 'domicile', nb: 1 });
  const creer = async e => { e.preventDefault(); try { const r = await creerTache(f); notifier?.(`Tâche créée${r.reparties ? `, répartie sur ${r.reparties} place(s)` : ''}`, 'success'); onCree(); } catch (x) { notifier?.(x.message, 'error'); } };
  return (
    <form onSubmit={creer} style={{ ...carte, borderColor: 'var(--accent)' }}>
      <div style={{ fontWeight: 700, marginBottom: 10 }}>Nouvelle tâche</div>
      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 8 }}>
        {ICONES.map(i => <button key={i} type="button" aria-pressed={f.icone === i} onClick={() => setF({ ...f, icone: i })}
          style={{ fontSize: 18, padding: '3px 7px', borderRadius: 8, cursor: 'pointer', background: f.icone === i ? 'rgba(230,57,70,.15)' : 'transparent', border: `1px solid ${f.icone === i ? 'var(--accent)' : 'var(--border)'}` }}>{i}</button>)}
      </div>
      <input style={{ ...champ, width: '100%', boxSizing: 'border-box', marginBottom: 8 }} required maxLength={40} placeholder="Nom de la tâche"
             value={f.nom} onChange={e => setF({ ...f, nom: e.target.value })} />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 10 }}>
        <select style={champ} value={f.quand} onChange={e => setF({ ...f, quand: e.target.value })} aria-label="Quand">
          {Object.entries(QUAND).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        <label style={petit}>Personnes par rencontre{' '}
          <select style={champ} value={f.nb} onChange={e => setF({ ...f, nb: Number(e.target.value) })}>{[1, 2, 3, 4, 5].map(n => <option key={n}>{n}</option>)}</select></label>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="btn btn-primary" style={{ width: 'auto' }}>Créer</button>
        <button type="button" className="btn btn-secondary" style={{ width: 'auto' }} onClick={onAnnule}>Annuler</button>
      </div>
    </form>);
}

export default function TachesPage() {
  const [d, setD] = useState(null); const [erreur, setErreur] = useState('');
  const [toast, setToast] = useState(null);
  const notifier = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 3200); };
  const [creation, setCreation] = useState(false); const [choix, setChoix] = useState(null);
  const charger = () => getTaches().then(setD).catch(e => setErreur(e.message));
  useEffect(() => { charger(); }, []);
  if (erreur) return <div className="page"><div style={carte}>{erreur}</div></div>;
  if (!d) return <div className="page" style={{ color: 'var(--muted)', padding: 20 }}>Chargement…</div>;
  const parId = Object.fromEntries(d.taches.map(t => [t.id, t]));
  const actives = d.taches.filter(t => t.actif);
  const agir = async (f, ok) => { try { const r = await f(); if (ok) notifier?.(typeof ok === 'function' ? ok(r) : ok, 'success'); charger(); } catch (x) { notifier?.(x.message, 'error'); } };
  const mesTaches = d.prochaines.flatMap(r => r.affectations.filter(a => a.moi && a.statut === 'prevu').map(a => ({ ...a, r })));

  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <div style={{ fontSize: 20, fontWeight: 800 }}>🧾 Tâches</div>
        {d.peut_gerer && actives.length > 0 && (
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-secondary" style={{ width: 'auto' }} onClick={() => agir(repartirTaches, r => r.reparties ? `${r.reparties} place(s) attribuée(s)` : 'Tout est déjà réparti')}>Répartir</button>
            {!creation && <button className="btn btn-primary" style={{ width: 'auto' }} onClick={() => setCreation(true)}>+ Nouvelle tâche</button>}
          </div>)}
      </div>

      {creation && <NouvelleTache notifier={notifier} onCree={() => { setCreation(false); charger(); }} onAnnule={() => setCreation(false)} />}

      {d.taches.length === 0 && !creation && (
        <div style={carte}>
          {d.peut_gerer ? (<>
            <div style={{ fontSize: 14, marginBottom: 10 }}>Définissez les tâches de l'équipe : elles seront réparties automatiquement et équitablement à chaque rencontre, et chacun sera prévenu de son tour.</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {SUGGESTIONS.map(([nom, icone, quand, nb]) => <button key={nom} className="btn btn-secondary" style={{ width: 'auto', fontSize: 13 }}
                onClick={() => agir(() => creerTache({ nom, icone, quand, nb }), `« ${nom} » créée`)}>{icone} {nom}</button>)}
              <button className="btn btn-primary" style={{ width: 'auto', fontSize: 13 }} onClick={() => setCreation(true)}>Autre…</button>
            </div></>)
            : <div style={{ fontSize: 14, color: 'var(--muted)' }}>Votre coach n'a pas encore défini de tâches pour l'équipe.</div>}
        </div>)}

      {mesTaches.length > 0 && (
        <div style={{ ...carte, borderColor: 'var(--accent)' }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Mes prochaines tâches</div>
          {mesTaches.map(a => (
            <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid var(--border)' }}>
              <div><b>{parId[a.tache_id]?.icone} {parId[a.tache_id]?.nom}</b><div style={petit}>{a.r.date_fr} · vs {a.r.adversaire}</div></div>
              <button style={lien} onClick={() => window.confirm('Vous ne pouvez pas assurer cette tâche ? Elle sera confiée à quelqu\'un d\'autre.') &&
                agir(() => indisponibleTache(a.id), r => r.remplacant ? `Confiée à ${r.remplacant}` : 'Personne de disponible : votre coach est prévenu')}>Je ne peux pas</button>
            </div>))}
        </div>)}

      {actives.length > 0 && d.prochaines.length > 0 && (
        <div style={carte}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Prochaines rencontres</div>
          {d.prochaines.map(r => {
            const lignes = actives.map(t => ({ t, a: r.affectations.filter(a => a.tache_id === t.id && a.statut === 'prevu') })).filter(x => x.a.length);
            return (
              <div key={r.id} style={{ padding: '8px 0', borderTop: '1px solid var(--border)' }}>
                <div style={{ fontSize: 13.5, fontWeight: 600 }}>{r.date_fr} · vs {r.adversaire} <span style={petit}>({r.dom_ext || 'Domicile'})</span></div>
                {lignes.length === 0 ? <div style={petit}>Aucune tâche pour cette rencontre</div> : lignes.map(({ t, a }) => (
                  <div key={t.id} style={{ fontSize: 13, marginTop: 3 }}>{t.icone} {t.nom} :{' '}
                    {a.map((x, i) => (
                      <span key={x.id}>{i > 0 && ', '}
                        {d.peut_gerer && choix === x.id
                          ? <select style={{ ...champ, padding: '2px 4px', fontSize: 12.5 }} autoFocus value={x.joueur_id}
                                    onChange={e => { setChoix(null); agir(() => reattribuerTache(x.id, Number(e.target.value)), 'Tâche confiée'); }} onBlur={() => setChoix(null)}>
                              {d.joueurs.map(j => <option key={j.id} value={j.id}>{j.prenom} {j.nom}</option>)}</select>
                          : <button style={{ all: 'unset', cursor: d.peut_gerer ? 'pointer' : 'default', fontWeight: x.moi ? 800 : 400, color: x.moi ? 'var(--accent)' : 'inherit',
                                             textDecoration: d.peut_gerer ? 'underline dotted' : 'none' }}
                                    onClick={() => d.peut_gerer && setChoix(x.id)} title={d.peut_gerer ? 'Confier à quelqu\'un d\'autre' : undefined}>{x.moi ? 'Moi' : x.nom}</button>}
                      </span>))}
                  </div>))}
              </div>);
          })}
        </div>)}

      {actives.length > 0 && d.equite.length > 0 && (
        <div style={{ ...carte, overflowX: 'auto' }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Depuis le début de la saison</div>
          <table style={{ borderCollapse: 'collapse', fontSize: 13, width: '100%' }}>
            <thead><tr><th style={{ textAlign: 'left', padding: '4px 6px', ...petit }}>Joueur</th>
              {actives.map(t => <th key={t.id} title={t.nom} style={{ padding: '4px 6px', ...petit }}>{t.icone || t.nom}</th>)}</tr></thead>
            <tbody>{d.equite.map(e => (
              <tr key={e.joueur_id} style={{ borderTop: '1px solid var(--border)', fontWeight: e.joueur_id === d.moi ? 700 : 400 }}>
                <td style={{ padding: '4px 6px' }}>{e.nom}</td>
                {actives.map(t => <td key={t.id} style={{ padding: '4px 6px', textAlign: 'center' }}>{e.compteurs[t.id] || 0}</td>)}
              </tr>))}</tbody>
          </table>
        </div>)}

      {d.peut_gerer && d.taches.length > 0 && (
        <div style={carte}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Tâches de l'équipe</div>
          {d.taches.map(t => (
            <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid var(--border)', opacity: t.actif ? 1 : .5 }}>
              <div><b>{t.icone} {t.nom}</b><div style={petit}>{QUAND[t.quand]} · {t.nb} personne{t.nb > 1 ? 's' : ''}{t.actif ? '' : ' · en pause'}</div></div>
              <div style={{ display: 'flex', gap: 12 }}>
                <button style={lien} onClick={() => agir(() => modifierTache(t.id, { actif: !t.actif }), t.actif ? 'Tâche mise en pause' : 'Tâche réactivée')}>{t.actif ? 'Pause' : 'Réactiver'}</button>
                <button style={{ ...lien, color: 'var(--danger)' }} onClick={() => window.confirm(`Supprimer « ${t.nom} » et son historique ?`) && agir(() => supprimerTache(t.id), 'Tâche supprimée')}>Supprimer</button>
              </div>
            </div>))}
        </div>)}
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </div>);
}
